import React from 'react'
import {Avatar as MuiAvatar, SxProps, Theme, useTheme} from '@mui/material'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface InitialsAvatarProps {
  /** Raw initials to display, e.g. "FL" — casing is normalized internally. */
  initials: string
  size?: number
  sx?: SxProps<Theme>
}

// Solid brand color, one color per PSP (theme.palette.primary.main), not a rotation, so it
// stays consistent with the rest of the portal's style instead of introducing hues the theme
// doesn't use. Text uses the PSP's configured dark-primary shade (palette.darkerColor, "Colore
// scuro primario") rather than palette.primary.dark — the latter is wired to the hover-button
// color for interactive states (see Button.tsx), not a readable-text shade, and MUI's
// auto-computed contrastText picks white for most PSP brand colors, which reads too faint here.
/** Small circular avatar showing 1-2 initials on the portal's primary brand color. */
export default function InitialsAvatar({initials, size = 32, sx}: InitialsAvatarProps): JSX.Element {
  const theme = useTheme()
  const normalized = (initials || '?').toUpperCase()

  return (
    <MuiAvatar
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        fontWeight: 700,
        bgcolor: theme.palette.primary.main,
        color: theme.palette.darkerColor?.main ?? NEUTRAL_SCALE[900],
        ...sx,
      }}
    >
      {normalized}
    </MuiAvatar>
  )
}
